import React from 'react';
import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import CreateDeliveryOtpForm from './CreateDeliveryOtpForm';
import Page from '../../components/Page/Page';
import DeliveriesOtpTracker from './DeliveriesOtpTracker';
import styles from './CreateDeliveryOtpPage.module.less';
import Title from '../../components/Page/Title';
import TitleIcon from '../../assets/img/titleIcon.svg?react';
import classnames from 'classnames';

const CreateDeliveryOtpPage = () => {
  const { t } = useTranslation();

  return (
    <Page className={styles.page}>
      <Row className={styles.container}>
        <Col xs={24} md={16} className={classnames([styles.fullHeight, styles.content])}>
          <Title text={t('deliveryOtps.createOtpTitle')} Icon={TitleIcon} />
          <CreateDeliveryOtpForm />
        </Col>
        <Col xs={24} md={8} className={styles.fullHeight}>
          <DeliveriesOtpTracker />
        </Col>
      </Row>
    </Page>
  );
};

export default CreateDeliveryOtpPage;
